// Which surface is rendering the article — public /help, authenticated
// /app/help, or the side panel — and how topic cross-links should behave there. Block renderers
// (the `related` list, prose links raised by future blocks) read this instead
// of guessing from the URL: on the page a topic link navigates; in the panel
// it swaps the panel's topic in place.
import { createContext, useContext } from "react";

export type HelpSurface = {
  surface: "page" | "panel";
  /** Root used by full-page links on this surface. */
  basePath: string;
  /** Open a topic on this surface. Accepts "topic-id" or "topic-id#anchor". */
  openTopic: (topic: string) => void;
  /** Full-page href for link semantics; panels intentionally omit it. */
  topicHref?: (topic: string) => string;
};

export const HelpSurfaceContext = createContext<HelpSurface | null>(null);

export function useHelpSurface(): HelpSurface | null {
  return useContext(HelpSurfaceContext);
}

/** Split "topic-id#anchor" into its parts. */
export function parseHelpTopic(topic: string): { topicId: string; anchor: string | null } {
  const hash = topic.indexOf("#");
  if (hash === -1) return { topicId: topic, anchor: null };
  return { topicId: topic.slice(0, hash), anchor: topic.slice(hash + 1) || null };
}
